<template>
    <el-dialog
    :title="title"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    width="87.5rem"
    :before-close="handleClose">
    <div class="content-box">
        <div v-if="changeType=='base'">
            <div class="title-box">
                <i class="spot"></i>
                <div>基本信息</div>
            </div>
            <div class="row-item">
                <div class="form-item">
                    <p>姓名</p>
                    <el-input v-model="form.userName" style="width: 19rem;" placeholder="请输入内容"></el-input>
                </div>
                <div class="form-item" style="margin-left: 2rem;">
                    <p>性别</p>
                    <el-radio-group v-model="form.sex">
                        <el-radio label="男">男</el-radio>
                        <el-radio label="女">女</el-radio>
                    </el-radio-group>
                </div>
            </div>
            <div class="row-item">
                <div class="form-item">
                    <p>省份</p>
                    <el-select v-model="form.address" style="width: 19rem;" placeholder="请选择">
                        <el-option
                        v-for="item in options"
                        :key="item"
                        :label="item"
                        :value="item">
                        </el-option>
                    </el-select>
                </div>
                <div class="form-item" style="margin-left: 2rem;">
                    <p>邮箱</p>
                    <el-input v-model="form.email" style="width: 19rem;" placeholder="请输入内容"></el-input>
                </div>
            </div>
            <div class="row-item">
                <div class="form-item">
                    <p>手机号码</p>
                    <el-input v-if="isChangeInfo=='phone'" @blur="isChangeInfo=''" v-model="form.phone" style="width: 19rem;" placeholder="请输入内容"></el-input>
                    <div v-else>{{ form.phone }}</div>
                    <div class="blue-label" v-if="!isChangeInfo" @click="isChangeInfo='phone'">更换手机</div>
                </div>
            </div>
            <div class="row-item">
                <div class="form-item">
                    <p>头像</p>
                    <el-upload
                    style="width: 50px !important; height: 50px !important"
                    action="#"
                    accept=".jpg,.jpeg,.png"
                    list-type="picture-card"
                    :auto-upload="false"
                    :show-file-list="false"
                    :on-change="handleFm"
                    >
                    <img
                        style="width: 48px; height: 48px;object-fit: cover;"
                        v-if="form.avatar"
                        :src="$severUrl(form.avatar)"
                        class="avatar"
                    />
                    <i v-if="!form.avatar" class="el-icon-plus"></i>
                    </el-upload>
                </div>
            </div>
        </div>
       <div v-else>
             <div class="title-box">
                <i class="spot"></i>
                <div>组织机构</div>
            </div>
            <div class="row-item">
                <div class="form-item">
                    <p>学校</p>
                    <el-select v-model="form.tenantId" style="width: 19rem;" placeholder="请选择">
                        <el-option
                        v-for="item in schoolOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div class="form-item" style="margin-left: 2rem;">
                    <p>角色</p>
                    <el-radio-group v-model="form.roleId">
                        <el-radio v-for="(item,index) in roleOptions" :key="index" :label="item.value">{{ item.label }}</el-radio>
                    </el-radio-group>
                </div>
            </div>
            <div class="row-item">
                <div class="form-item">
                    <p>工号/学号</p>
                    <el-input v-model="form.number" style="width: 19rem;" placeholder="请输入内容"></el-input>
                </div>
            </div>
            <div class="row-item">
                <div class="form-item">
                    <p>身份认证</p>
                    <div :style="`font-size: 14px;`">{{ filterStatus(form.authStatus) }}</div>
                </div>
            </div>
       </div>
    </div>
    <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" v-debounce="save">保 存</el-button>
    </div>
    </el-dialog>
</template>

<script>
import { SchoolSelect } from '@/api/systemAuth';
import {QueryUserInfo,EditBaseInfo,RealName,GetBusinessRole} from '@/api/user';
import { uploadFile } from '@/assets/js/oss';
    export default {
        props:['changeType'],
        data(){
            return {
                dialogVisible:false,
                title:'',
                form:{
                "address": "",
                "avatar": "",
                "current": 1,
                "email": "",
                "expirationTime": "",
                "id": "",
                "loginName": "",
                "number": "",
                "passwd": "",
                "phone": "",
                "id":'',
                "schoolId": "",
                "schoolName": "",
                "sex": "",
                "size": 10,
                "tenantId": "",
                "userName": ""
                },
                /**修改密码 */
                isChangeInfo:'',
                /**省份 */
                options:[
                    "北京市",
                    "天津市",
                    "河北省",
                    "山西省",
                    "内蒙古自治区",
                    "辽宁省",
                    "吉林省",
                    "黑龙江省",
                    "上海市",
                    "江苏省",
                    "浙江省",
                    "安徽省",
                    "福建省",
                    "江西省",
                    "山东省",
                    "河南省",
                    "湖北省",
                    "湖南省",
                    "广东省",
                    "广西壮族自治区",
                    "海南省",
                    "重庆市",
                    "四川省",
                    "贵州省",
                    "云南省",
                    "西藏自治区",
                    "陕西省",
                    "甘肃省",
                    "青海省",
                    "宁夏回族自治区",
                    "新疆维吾尔自治区",
                    "台湾省",
                    "香港特别行政区",
                    "澳门特别行政区"
                ],
                /**院校 */
                schoolOptions:[],
                /**角色可选项 */
                roleOptions:[]
            }
        },
        methods:{
            /**认证状态过滤 */
            filterStatus(status){
                var obj={
                   '-1':'无认证',
                   0:'未认证',
                   1:'已认证',
                   2:'认证中',
                   3:'认证失败'
                }
                return obj[status]||{};
            },
            /**获取内置业务角色 */
            getBusinessRole(){
                GetBusinessRole().then(res=>{
                    if(res.code==200){
                        this.roleOptions=res.data.map(item=>{
                            return {
                                label:item.name,
                                value:item.value
                            }
                        })
                    }
                })
            },
            /**获取学校下拉 */
            querySchool(){
                SchoolSelect().then(res=>{
                    if(res.code==200){
                        this.schoolOptions=res.data.map(item=>{
                            return {
                                label:item.tenantName,
                                value:item.tenantCode
                            }
                        })
                    }
                })
            },
            /**上传头像 */
            handleFm(e){
                uploadFile(e.raw).then(res=>{
                    this.form.avatar=res.previewUrl;
                })
            },
            handleClose(){
                this.dialogVisible=false;
            },
            /**获取基本用户信息 */
            queryUserInfo(){
                QueryUserInfo().then(res=>{
                    if(res.code==200){
                        this.$store.commit('changeUserInfo',res.data);
                    }
                })
            },
            /**保存 */
            save(){
                var params={};
                if(this.changeType=='base'){
                    params={
                        userName:this.form.userName,
                        sex:this.form.sex,
                        id:this.form.id,
                        avatar:this.form.avatar,
                        address:this.form.address,
                        email:this.form.email,
                        phone:this.form.phone,
                        loginName:this.form.loginName
                    }
                    EditBaseInfo(params).then(res=>{
                        if(res.code==200){
                            this.$msg({
                                showClose: true,
                                message: "修改成功",
                                type: "success",
                            });
                            this.dialogVisible=false;
                            this.queryUserInfo();
                        }
                    })
                }else{
                    params={
                        "roleId": this.form.roleId,
                        "id":this.form.id,
                        "number":this.form.number,
                        "tenantId": this.form.tenantId
                    }
                    let obj={
                        tenantId:'学校不能为空',
                        number:'学号不能为空',
                        roleId:'角色不能为空'
                    };
                    for(let key in obj){
                        if(!params[key]){
                            this.$msg({
                                showClose: true,
                                message: obj[key],
                                type: "warning",
                            });
                            return;
                        }
                    }
                    RealName(params).then(res=>{
                        if(res.code==200){
                            this.$msg({
                                showClose: true,
                                message: "申请认证成功",
                                type: "success",
                            });
                            this.dialogVisible=false;
                            this.queryUserInfo();
                        }
                    })
                }
            }
        },
    }
</script>

<style lang="less" scoped>
/deep/.el-dialog__title{
    font-weight: 700;
    font-size: 16px;
}
/deep/.el-dialog{
    border-radius: 1rem;
}
.content-box{
    padding: 3rem;
    border: 1px solid #e8ecef;
    border-radius: 10px;
    box-shadow: 0px 0px 15px 0px rgba(231,236,239,0.10); 
}
.dialog-footer{
    display: flex;
    justify-content: center;
    &> :nth-child(2){
        margin-left: 3.5rem;
    }
}
.spot{
    width: 0.6rem;
    height: 0.6rem;
    background-color: var(--blue);
    margin-right: 2rem;
}
.title-box{
    display: flex;
    align-items: center;
}
.form-item{
    display: flex;
    align-items: center;
    &> :nth-child(1){
        color: #8590B3;
        font-size: 14px;
        margin-right: 1rem;
        width: 8rem;
        text-align: right;
    }
}
.row-item{
    display: flex;
    margin-top: 2.5rem;
}
.blue-label{
    width: 70px;
    height: 26px;
    background: rgba(56,125,255,0.10);
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #387DFF;
    margin-left: 1rem;
    cursor: pointer;
}
/deep/.el-upload{
  width: 50px;
  height: 50px;
  position: relative;
}
/deep/.el-icon-plus{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
}
@media screen and (max-width:750px){
    /deep/.el-dialog{
        width: 100% !important;
    }
}
@media screen and (max-width: 450px) {
    .row-item{
        display: block !important;
        &> :nth-child(2){
            margin-left: 0 !important;
            margin-top: 2.5rem;
        }
    }
}
</style>